var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.495,
    height: 14.495,
    viewBox: "0 0 14.495 14.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12843",
    "data-name": "Group 12843",
    transform: "translate(-1483.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10323",
    "data-name": "Path 10323",
    d: "M132.549,194.183a1.673,1.673,0,0,0-1.673-1.673h-6.69a1.672,1.672,0,0,0-1.672,1.673v6.69a1.672,1.672,0,0,0,1.672,1.673h6.69a1.673,1.673,0,0,0,1.673-1.673Z",
    transform: "translate(1360.829 -188.05)",
    fill: "#0376a8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10324",
    "data-name": "Path 10324",
    d: "M262.5,55.845V54.173a1.672,1.672,0,0,1,1.673-1.673h6.69a1.672,1.672,0,0,1,1.673,1.673v6.69a1.672,1.672,0,0,1-1.673,1.673H269.19v-3.9a2.788,2.788,0,0,0-2.788-2.788Z",
    transform: "translate(1225.303 -52.5)",
    fill: "#0376a8",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.fe4faaa56b00b8d7b76979e08ca4025e.svg";
export { ForwardRef as ReactComponent };